import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {Select, Store} from '@ngxs/store';
import {ActiveProductsActions} from '../../../state/active-products/active-products.action';
import {ActiveProductState} from '../../../state/active-products/active-products.state';
import {ActiveProducts} from '../../../models/product.model';
import {map, withLatestFrom} from 'rxjs/operators';

@Injectable()
export class ActiveProductsResolver implements Resolve<any> {
    @Select(ActiveProductState.activeProducts) activeProducts$: Observable<ActiveProducts>;
    constructor(
        private store: Store,
    ) {
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        return this.store.dispatch(new ActiveProductsActions.ActiveProducts())
            .pipe(
                withLatestFrom(this.activeProducts$),
                map(([, activeProducts]) => activeProducts)
            );
    }
}
